goog.provide('el8.appchart.actions.problems');

goog.require('el8.appchart.dialog.addEditProblem');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appchart.refpanel.demog');
goog.require('el8.ptdata.ptProblems');
goog.require('el8.ptdata.hccScoreDetails');


el8.appchart.actions.problems = function(opts) {

    opts = opts || {};
    var patientProblem = opts.item;
    var menu = [];


    if (el8Globals.TEASE) { return []; }

    if (!patientProblem) {
        var refStr = el8.ptdata.ptProblems.getDocumentedAsNoneSummary();
        return [
            {
                actionText: 'Export to Note (HPI)',
                actionFn: function(){
                    el8.appchart.mgr.notes.addText(refStr, 'problem');
                }
            },
            {
                actionText: 'Export to Note (ROS)',
                actionFn: function(){
                    el8.appchart.mgr.notes.addText(refStr, 'ros');
                }
            },
            {
                actionText: 'Export to Note (A)',
                actionFn: function(){
                    el8.appchart.mgr.notes.addText(refStr, 'assessment');
                }
            },
            {
                actionText: 'Remove',
                actionFn: function() {
                    el8.ptdata.ptProblems.deleteAsDocumented();
                }
            }
        ];
    }

    menu.push({
        actionText: 'Edit',
        actionFn: function() {
            el8.appchart.dialog.addEditProblem.show({'problem':patientProblem});
        }
    });

    var hasBillReferenceableCodes = function() {
        // ICD-9s are not referenceable into bills anymore
        return patientProblem.getImoIds().length;
    };
    var addToBill = function(_ptProblem) {
        if (el8Globals['FEATURES']['AutoImportBilling'] &&
                _ptProblem.getImoIds() && _ptProblem.getImoIds().length) {

            el8.appchart.mgr.notes.appendBillingDiagnoses({
                imoIds: _ptProblem.getImoIds()
            });
        }
    };

    var updateHCCOpts = function() {
        var opts = {};
        // refresh and rerender hcc score
        opts.successCb = function() { el8.ptdata.hccScoreDetails.refreshIfHccScoreEnabled(); };
        return opts;
    };

    if (el8.appchart.actions.problems.isHpiAComboExportRelevant()) {
        var actionText = (el8Globals['FEATURES']['AutoImportBilling'] && hasBillReferenceableCodes()) ?
            'Export to Note (HPI, A, Billing)' : 'Export to Note (HPI, A)';
        menu.push({
            actionText: actionText,
            actionFn: function(){
                el8.appchart.mgr.notes.addReference({item: patientProblem });
                el8.appchart.mgr.notes.addReference({item: patientProblem, sectionName: 'assessment'});
                addToBill(patientProblem);
            }
        });
    }
    menu.push({
        actionText: 'Export to Note (HPI)',
        actionFn: function(){
            el8.appchart.mgr.notes.addReference({item: patientProblem });
        }
    });
    menu.push({
        actionText: 'Export to Note (ROS)',
        actionFn: function(){
            el8.appchart.mgr.notes.addReference({item: patientProblem, sectionName: 'ros'});
        }
    });
    var actionText = (el8Globals['FEATURES']['AutoImportBilling'] && hasBillReferenceableCodes()) ?
        'Export to Note (A, Billing)' : 'Export to Note (A)';
    menu.push({
        actionText: actionText,
        actionFn: function(){
            el8.appchart.mgr.notes.addReference({item: patientProblem, sectionName: 'assessment'});
            addToBill(patientProblem);
        }
    });
    var actionText = (el8Globals['FEATURES']['AutoImportBilling'] && hasBillReferenceableCodes()) ?
        'Export to Note w/ Synopsis (A, Billing)' : 'Export to Note w/ Synopsis (A)';
    if (patientProblem.getDetails()) {
        menu.push({
            actionText: actionText,
            actionFn: function(){
                el8.appchart.mgr.notes.addProblemWithDetails(patientProblem);
            }
        });
    }
    if (el8Globals['FEATURES']['AutoImportBilling']) {
        if (hasBillReferenceableCodes()) {
            menu.push({
                actionText: 'Export to Note (Billing)',
                actionFn: function() { addToBill(patientProblem); }
            });
        } else {
            menu.push({
                actionSafeText: '<span class="disabled">Export to Note (Billing)<br />(Crosswalk to Enable)</span>',
                actionFn: function() {
                    el8.appchart.dialog.addEditProblem.show({
                        problem: patientProblem,
                        saveCb: addToBill
                    });
                }
            });
        }
    }
    if(patientProblem.getStatus() !== 'Active'){
        menu.push({
            actionText: 'Mark as Active',
            actionFn: function() {
                var opts = updateHCCOpts();
                patientProblem.setAsActive();
                el8.ptdata.ptProblems.saveItem(patientProblem, false, opts);
            }
        });
    }

    if(patientProblem.getStatus() !== 'Controlled'){
        menu.push({
            actionText: 'Mark as Controlled',
            actionFn: function() {
                var opts = updateHCCOpts();
                patientProblem.setAsControlled();
                el8.ptdata.ptProblems.saveItem(patientProblem, false, opts);
            }
        });
    }

    if(patientProblem.getStatus() !== 'Resolved'){
        menu.push({
            actionText: 'Mark as Resolved',
            actionFn: function(){
                var opts = updateHCCOpts();
                patientProblem.setAsResolved();
                el8.ptdata.ptProblems.saveItem(patientProblem, false, opts);
            }
        });
    }

    menu.push({
        actionText : 'Remove',
        actionFn: function(){
            var opts = updateHCCOpts();
            var newOpts = {}
            newOpts.successCb = function(){
                opts.successCb();
            }

            el8.ptdata.ptProblems.deleteItem(patientProblem, false, newOpts);
        }
    });

    return menu;

};

/*
 * This combo element is relevant if we have a two col visit note open,
 * or if the default visit note type is a two col note and we don't currently
 * have another kind of note open.
 */
el8.appchart.actions.problems.isHpiAComboExportRelevant = function() {
    var defaultTemplateType = el8.data.noteSettings.getDefaultVisitNoteTemplate() ||
                              el8.util.consts.DEFAULT_VISIT_NOTE_TEMPLATE;

    var defaultTemplateTypeIsTwoCol = defaultTemplateType.startswith('twoCol');
    var visitIsOpen = el8.appchart.visitNote.main.isOpen();
    var nonvisitIsOpen = el8.appchart.nonvisitNote.main.isOpen();

    return ( visitIsOpen && el8.appchart.visitNote.main.isTwoColComplex() ) ||
           ( defaultTemplateTypeIsTwoCol && !visitIsOpen && !nonvisitIsOpen );
};
